import script from "./IOrderMenuNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./IOrderMenuNew.vue?vue&type=script&setup=true&lang=ts"

import "./IOrderMenuNew.vue?vue&type=style&index=0&id=4ff9ddab&lang=scss"

const __exports__ = script;

export default __exports__